var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangleRedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99981 13.6106C8.79223 13.6179 8.58997 13.5442 8.43586 13.4051C8.13857 13.0769 8.13857 12.5772 8.43586 12.249C8.58828 12.1065 8.79121 12.0305 8.99984 12.0377C9.21255 12.0292 9.41914 12.11 9.56956 12.2604C9.71542 12.4114 9.7938 12.6149 9.78679 12.8246C9.79793 13.0358 9.72416 13.2427 9.58186 13.3993C9.42564 13.5474 9.21478 13.624 8.99981 13.6106Z",
    fill: "#F03823"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99922 10.575C8.62656 10.575 8.32422 10.2727 8.32422 9.9V6.3C8.32422 5.92735 8.62656 5.625 8.99922 5.625C9.37187 5.625 9.67422 5.92735 9.67422 6.3V9.9C9.67422 10.2727 9.37187 10.575 8.99922 10.575Z",
    fill: "#F03823"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0597 16.1998H2.93958C2.21932 16.1998 1.56893 15.8307 1.20023 15.2119C0.831522 14.5932 0.8157 13.8452 1.15847 13.2115L7.21854 2.00899C7.57274 1.3542 8.25522 0.947266 8.99964 0.947266C9.74407 0.947266 10.4265 1.3542 10.7807 2.00899L16.8408 13.2115C17.1836 13.8452 17.1678 14.5932 16.7991 15.2119C16.4304 15.8307 15.78 16.1998 15.0597 16.1998ZM8.99964 2.29727C8.87879 2.29727 8.57865 2.33155 8.40594 2.65059L2.34588 13.8531C2.18108 14.1581 2.30062 14.4218 2.35994 14.5202C2.41883 14.6195 2.59329 14.8498 2.93957 14.8498H15.0597C15.406 14.8498 15.5804 14.6195 15.6393 14.5202C15.6987 14.4218 15.8182 14.1581 15.6534 13.8531L9.59335 2.65059C9.42065 2.33155 9.1205 2.29727 8.99964 2.29727Z",
    fill: "#F03823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleRedIcon);
export default __webpack_public_path__ + "static/media/alert-triangle-red-icon.25995ec81811e2b7944328b3685d5e8c.svg";
export { ForwardRef as ReactComponent };